import React from 'react';
import { Eyebrow } from './Eyebrow';
export function ClosingWords() {
  return <section aria-labelledby="closing-heading" className="bg-night py-16 sm:py-24" data-id="element-48" data-mp="3mv32iw7qomcj">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-49" data-mp="3mt0h6phj7he5">
        <Eyebrow align="center" data-id="element-50" data-mp="3hu5n2re466eq">Na koniec</Eyebrow>
        <h2 id="closing-heading" className="mt-5 font-display text-4xl leading-[0.95] sm:text-7xl" data-id="element-51" data-mp="3duexgr0bpwbs">
          <span className="block text-cream" data-id="element-52" data-mp="38usdzztwjjuj">Przestań improwizować.</span>
          <span className="block text-amber" data-id="element-53" data-mp="38wvc7757kjac">Zacznij projektować.</span>
        </h2>
        <p className="mt-7 font-serif text-lg italic leading-relaxed text-cream-soft sm:text-xl" data-id="element-54" data-mp="3430qjy61lu8m">
          Latami doskonaliłeś grę na gitarze jazzowej. Zasługujesz na system nauczania, który
          dorównuje Twojej muzykalności — i pozwala zaplanować cały rok w kilka wieczorów, a nie w
          kilkadziesiąt.
        </p>
        <p className="mt-8 text-sm font-semibold uppercase tracking-label text-amber" data-id="element-55" data-mp="2l5hl14ismtqy">
          Koniec z chaosem. Czas na system.
        </p>
      </div>
    </section>;
}